import { sectionPath } from '../../lib/config';

const setCategory = () => {
    const currentUrl = window.location.href;

    const filters = {
        filter_article: `articles/${sectionPath.article}`,
        filter_stream: '/stream/',
        filter_news: `articles/${sectionPath.news}`,
        filter_tv: 'epg',
    };
    let filter;

    for (const key in filters) {
        if ({}.hasOwnProperty.call(filters, key)) {
            if (currentUrl.indexOf(filters[key]) !== -1) {
                filter = key;
            }
        }
    }

    return filter;
};

export default setCategory;



// WEBPACK FOOTER //
// src/components/media/setCategory.js